<template>
  <div class="container">
      请使用微信扫码
  </div>
</template>

<script>

  export default {
    components: {

    },
    name: 'Index',
    // props: {
    //   msg: String
    // },
    data() {
      return {
        loading: false
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {}
    }
  }
</script>

<style scoped>
.container{
  width: 100%;
  padding-top: 50px;
  text-align:center;

}
</style>